import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'jhi-type-acte-attaque-info',
  templateUrl: './type-acte-attaque-info.component.html',
  styleUrls: ['./type-acte-attaque-info.component.scss']
})
export class TypeActeAttaqueInfoComponent implements OnInit {

  @Input()
  typeActeAttaqueCode: string;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/juridiction/type-acte-attaque-section/type-acte-attaque-info/type-acte-attaque-info.component.ts